import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { copyText: String, successMessage: String };

  copy() {
    const escapedtext = this.copyTextValue;
    const unescapedtext = unescape(escapedtext);

    navigator.clipboard.writeText(unescapedtext);

    toastr.success(this.successMessageValue);
  }
}
